import currency from "currency.js";
import { ONEPASS_APPLIES_TO_TREATMENT_PLANS, ONEPASS_DISCOUNT_CODE } from "../constants.js";
import discounts_model from "./discounts_model";
import med_model from "@iscr/models/med_model";
import script_model from "@iscr/models/script_model";

export default class onepass_model {
	static isValidOnepassMember() {
		return app?.user?.prof?.onepass;
	}

	/**
	 *
	 * @param {med_db_data|cart_model.content} data
	 * @param {Object=null} type
	 * @param {string} type.script_type
	 * @param {string} type.req_type
	 * @returns
	 */
	static isValidOnepassItem(data, type) {
		if (app?.runtime?.mode !== "iscr") {
			return false;
		}

		if (!app?.app_data?.ws_data?.cat_data?.["pharm"]) {
			return false;
		}

		if (data?.f?.cst?.toString().toLowerCase().includes("medicare rebate")) {
			return false
		}

		if (["docconswlo", "docconswli"].includes(data?.req_tp)) {
			return false;
		}

		if (["DocConsWLOral", "DocConsWLInj"].includes(data?.c)) {
			return false;
		}

		if (med_model.has_copay(data)) {
			return false;
		}

		if (type) {
			if (script_model.is_treatment_plan_consult(type) || script_model.is_treatment_plan_med(type)) {
				return ONEPASS_APPLIES_TO_TREATMENT_PLANS;
			}
		}

		if (data?.need_qual) {
			return true;
		}

		return ["doccons", "medcons", "cert", "patho", "specialist-referrals"].some(element => (
			data?.c?.toLowerCase().includes(element) ||
			data?.par_id?.toLowerCase().includes(element) ||
			data?.l?.toLowerCase().includes(element) ||
			data?.m?.toLowerCase().includes(element) ||
			data?.itm_tp?.toLowerCase().includes(element) ||
			data?.items?.map(({ id }) => id?.toLowerCase()).includes(element)
		));
	}

	static discountedPriceString(onepassDiscount, originalPrice, excludedPriceFromDiscount = 0) {
		if (!onepassDiscount) {
			return currency(originalPrice).format();
		}
		const percentageAmount = onepassDiscount?.conf?.amount / 100;
		if (excludedPriceFromDiscount) {
			return currency(originalPrice)
				.subtract(excludedPriceFromDiscount)
				.multiply(1 - percentageAmount)
				.add(excludedPriceFromDiscount)
				.format();
		} else {
			return currency(originalPrice)
				.multiply(1 - percentageAmount)
				.format();
		}
	}

	static getOnePassDiscountAmountAndLabel(onepassDiscount, originalPrice) {
		if (!onepassDiscount) {
			return { amount: currency(originalPrice).format() };
		}
		const percentageAmount = onepassDiscount?.conf?.amount / 100;
		const amountString = `${onepassDiscount?.conf?.amount}%`;
		return {
			amount: currency(originalPrice).multiply(percentageAmount).format(),
			label:
				onepassDiscount.code === ONEPASS_DISCOUNT_CODE
					? `${amountString} discount for OnePass members`
					: `${amountString} discount for OnePass members on their first transaction`,
		};
	}

	static async getOnePassDiscount() {
		const result = this.isValidOnepassMember() && await discounts_model.get_discount_by_code(ONEPASS_DISCOUNT_CODE);
		if (result?.res === "ok") {
			return result;
		}
		return null;
	}
}
